<script>
	import Sparkline from './Sparkline.svelte';
	
	export let data1 = [];
	export let data2 = [];
	export let data1Color = "green";
	export let data2Color = "red";
	export let width = 100;
  export let tooltip = "";
  export let style = "";
	
	$: max1 = Math.max(...data1.map(x => x.y));
	$: max2 = Math.max(...data2.map(x => x.y));
	$: yScaleMax = Math.max(max1, max2);
</script>

<div class="container" {style} on:click>
	<div class="grid">
		<div class="sparkline">
			<Sparkline data={data1} color={data1Color} {width} lastPointMarker {yScaleMax} />
		</div>
		<div class="sparkline">
			<Sparkline data={data2} color={data2Color} {width} lastPointMarker {yScaleMax} />
		</div>
	</div>
  <div title={tooltip}>
    <span style="color: {data1Color}">{data1[data1.length - 1]?.y || ""}</span>
    <span style="color: {data2Color}">{data2[data2.length - 1]?.y || ""}</span>
  </div>
</div>
	
<style>
	.container {
		display: flex;
		flex-direction: row;
		gap: 5px;
	}
	
	.grid {
		display: grid;
	}
	
	.sparkline {
		grid-row-start: 1;
		grid-column-start: 1;
	}

  * {
    user-select: none;
  }
</style>